import { BaseModel } from 'storm-react-diagrams';
import { DesignChangeMap } from '../../../../types';
import { getModelIcon } from '../../../functions';
import { BaseChangeItemConflict } from '../types';

export interface GetConflictItemIconProps {
  conflictItem: BaseChangeItemConflict;
  model: BaseModel<any> | null;
}

export function getConflictItemIcon({
  conflictItem,
  model
}: GetConflictItemIconProps): string | null {
  const { key } = conflictItem;
  const designKey = key.split('.')[0] as keyof(DesignChangeMap);
  switch (designKey) {
    case 'appProperties':
    case 'applicationVersion':
    case 'ccxml':
    case 'dialogs':
    case 'fillerPrompts':
    case 'folders':
    case 'intentHandling':
    case 'languages':
    case 'unitTests':
      return null;
    case 'application-intents':
    case 'application-modules':
    case 'application-objects':
    case 'application-variables':
    case 'modules':
      if (!model) {
        console.error('No model for provided for conflict item.', conflictItem);
        return null;
      }

      return getModelIcon(model);
    case 'compoundIntents':
      return 'compass';
    case 'csvData':
      return 'grid';
    case 'functions':
      return 'server';
    case 'globalIntents':
      return 'radio';
    case 'graphQLSchemas':
      return 'graphql';
    case 'settings':
      return 'settings';
    default: {
      const neverKey: never = designKey;
      console.error(`No icon configured for key '${neverKey}'.`);
    }
  }

  return null;
}
